module.exports = __webpack_public_path__ + "media/img/avt-mr-nhat-127983a9.png";